import React from 'react'
import { Box } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

interface OptionType {
  label: string
  value: string | null
}

interface VerificationFilterProps {
  value: string | null
  onChange: (newValue: string | null) => void
}

const VerificationFilter: React.FC<VerificationFilterProps> = ({
  value,
  onChange,
}) => {
  const options: OptionType[] = [
    { label: 'Verified', value: 'Success' },
    { label: 'Not Verified', value: 'Fail' },
  ]

  const handleOptionChange = (
    event: React.SyntheticEvent,
    newValue: OptionType | null,
  ) => {
    onChange(newValue ? newValue.value : null)
  }

  return (
    <Box sx={{ width: { xs: '100%', sm: 160, md: 200 }, margin: 'auto' }}>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option.label}
        value={options.find((option) => option.value === value) || null}
        onChange={handleOptionChange}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            fullWidth
            placeholder="Select Status"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '57px',
                height: '48px',
                color: 'white',
                padding: '0px 15px ',
              },
              '& .MuiInputLabel-root': {
                fontSize: '1rem',
                color: 'white',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
                backgroundColor: '#ffffff20',
                color: 'white',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#1976d2',
              },
            }}
          />
        )}
        isOptionEqualToValue={(option, val) => option.value === val?.value}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: '#10131a',
              color: '#7d7d7d',
              borderRadius: '8px',
              boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
              '& .MuiAutocomplete-listbox': {
                padding: '0px',
                '& .MuiAutocomplete-option': {
                  '&[aria-selected="true"]': {
                    backgroundColor: '#FB5012 !important',
                    color: 'white',
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(251, 80, 18, 0.1)',
                  },
                },
              },
            },
          },
        }}
      />
    </Box>
  )
}

export default VerificationFilter
